import { Dispatch } from "redux";
import { OpenAlert } from "../../alert/action";
import { setUserInfo } from "../../user/action";
import * as requestToServer from "./barracksCruds";
import { barracksSlice } from "./barracksSlice";

const { actions } = barracksSlice;

const fetchPlayerTroop = (count: number) => (dispatch: Dispatch) => {
  dispatch(actions.loading(true));

  return requestToServer
    .getPlayerTroop(count)
    .then((response: any) => {
      if (response?.ok) {
        dispatch(actions.playerTroopFetched(response?.data?.data));
      } else {
        dispatch(
          OpenAlert({ msg: response?.message, open: true, variant: "error" })
        );
      }
    })
    .catch((error) => {
      dispatch(
        OpenAlert({ msg: error?.message ?? "", open: true, variant: "error" })
      );
    })
    .finally(() => {
      dispatch(actions.loading(false));
    });
};

const fetchBarracksBuildingInfo = () => (dispatch: Dispatch) => {
  return requestToServer
    .getBarracksBuildingInfo()
    .then((response: any) => {
      if (response?.ok) {
        dispatch(actions.barrackBuildingInfoFetched(response?.data));
      } else {
        dispatch(
          OpenAlert({ msg: response?.message, open: true, variant: "error" })
        );
      }
    })
    .catch((error) => {
      dispatch(
        OpenAlert({ msg: error?.message ?? "", open: true, variant: "error" })
      );
    });
};

const fetchGetMe = () => (dispatch: Dispatch) => {
  return requestToServer
    .getterGetMe()
    .then((response: any) => {
      if (response?.ok) {
        dispatch(setUserInfo(response?.data));
      } else {
        dispatch(
          OpenAlert({ msg: response?.message, open: true, variant: "error" })
        );
      }
    })
    .catch((error) => {
      dispatch(
        OpenAlert({ msg: error?.message ?? "", open: true, variant: "error" })
      );
    });
};

const fetchTroopLevels = () => (dispatch: Dispatch) => {
  return requestToServer
    .getTroopLevels()
    .then((response: any) => {
      if (response?.ok) {
        return response;
      } else {
        dispatch(
          OpenAlert({ msg: response?.message, open: true, variant: "error" })
        );
      }
    })
    .catch((error) => {
      dispatch(
        OpenAlert({ msg: error?.message ?? "", open: true, variant: "error" })
      );
    });
};

const trainRequestPlayerTroop =
  (troopId: { troopId: number }) => (dispatch: Dispatch) => {
    return requestToServer
      .trainRequestPlayerTroop(troopId)
      .then((response: any) => {
        if (response?.ok) {
          return response;
        } else {
          dispatch(
            OpenAlert({ msg: response?.message, open: true, variant: "error" })
          );
        }
      })
      .catch((error) => {
        dispatch(
          OpenAlert({ msg: error?.message ?? "", open: true, variant: "error" })
        );
        return error;
      });
  };

export {
  fetchBarracksBuildingInfo,
  fetchGetMe,
  fetchPlayerTroop,
  fetchTroopLevels,
  trainRequestPlayerTroop,
};
